import { CallHistory } from 'pages/ContractPage/components/CallHistory/CallHistory'
import { Client } from 'pages/ContractPage/components/Client/Client'
import { Comments } from 'pages/ContractPage/components/Comments'
import { Contract } from 'pages/ContractPage/components/Contract/Contract'
import { EventsHistory } from 'pages/ContractPage/components/EventsHistory/EventsHistory'
import { FileContract } from 'pages/ContractPage/components/FileContract/FileContract'
import { FinanceInformation } from 'pages/ContractPage/components/FinanceInformation/FinanceInformation'
import { LawHistory } from 'pages/ContractPage/components/LawHistory/LawHistory'

export const getTabs = hasLegalProceedings => {
  const tabs = [
    {
      label: 'Финансовая информация',
      component: FinanceInformation
    },
    {
      label: 'Контракт',
      component: Contract
    },
    {
      label: 'Клиент',
      component: Client
    },
    {
      label: 'История действий',
      component: EventsHistory
    },
    {
      label: 'Звонки',
      component: CallHistory
    },
    {
      label: 'Комментарии',
      component: Comments
    },
    {
      label: 'Загруженные файлы',
      component: FileContract
    }
  ]

  if (hasLegalProceedings) {
    tabs.push({
      label: 'Судебный процесс',
      component: LawHistory
    })
  }

  return tabs
}
